import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const lightBulbIcon: SvgIconData = {
  viewBox: '5 2 14 20',
  element: (
    <path d="M12 2a7 7 0 0 0-7 7 7 7 0 0 0 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26A7 7 0 0 0 19 9a7 7 0 0 0-7-7M9 21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1H9v1Z"></path>
  ),
};
